import { G2S } from '../g2s';
import * as api from '../api';

export class ContentService {
    getHygge(): Promise<api.HyggeResult> {
        return new Promise<api.HyggeResult>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Content/Hygge',
                    {}
                )
                .then(function (response) {
                    resolve(<api.HyggeResult>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getText(id: string): Promise<api.ContentText> {
        return new Promise<api.ContentText>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Content/Text',
                    {
                        id: id
                    }
                )
                .then(function (response) {
                    resolve(<api.ContentText>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getSupportContacts(): Promise<api.SupportContacts> {
        return new Promise<api.SupportContacts>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Content/SupportContacts',
                    {}
                )
                .then(function (response) {
                    resolve(<api.SupportContacts>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
